import { render, staticRenderFns } from "./Login-admin.vue?vue&type=template&id=39c47ad0&scoped=true&"
import script from "./Login-admin.vue?vue&type=script&lang=js&"
export * from "./Login-admin.vue?vue&type=script&lang=js&"
import style0 from "./Login-admin.vue?vue&type=style&index=0&id=39c47ad0&prod&scoped=true&lang=css&"
import style1 from "./Login-admin.vue?vue&type=style&index=1&id=39c47ad0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c47ad0",
  null
  
)

export default component.exports